import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { identity } from 'ramda';

import { Container, CloseIcon, LogoImg, Title, CloseButton } from './modal.styles';

export class Modal extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.any,
    onClose: PropTypes.func,
  };

  static defaultProps = {
    onClose: identity,
  };

  handleCloseClick = () => this.props.onClose();

  render() {
    return (
      <Container className={this.props.className}>
        <CloseButton onClick={this.handleCloseClick}>
          <CloseIcon />
        </CloseButton>
        <LogoImg />
        <Title>{this.props.title}</Title>
        {this.props.children}
      </Container>
    );
  }
}
